export default __webpack_public_path__ + "static/media/experimental_poster.5b3befa6.svg";